export default __webpack_public_path__ + "static/media/icon-playerfm.a22bb9a6.svg";